<template>
	<div class="complate ma-4">
		<div v-if="isSuccess">
			<h1>URL認証完了</h1>
			<div class="mt-4">
				<div>
					<p>認証が完了しました。ありがとうございます。</p>
					<p>まもなくトップ画面へ遷移します。</p>
				</div>
			</div>
		</div>
		<div v-if="!isSuccess && isSuccess !== null">
			<h1>URL認証失敗</h1>
			<div class="mt-4">
				<div>
					<p class="red--text">認証に失敗しました。</p>
					<p class="red--text">お手数ですが再度ログインからやり直してください。</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import errorHandling from "../../helper/errorHandling"

export default {
	data() {
		return {
			renderTo: null,
			isSuccess: null,
		}
	},
	mounted() {
		this.setConfirmationToken()
	},
	methods: {
		redirectTo(path) {
			setTimeout(() => {
				this.$router.replace(path)
			}, 3000)
		},
		setConfirmationToken() {
			const confirmation_token = this.$route.query.confirmation_token || null
			this.$store
				.dispatch("auth/confirmToken", confirmation_token)
				.then((res) => {
					this.isSuccess = true
					this.$store.commit("setFlash", {
						type: "notice",
						text: "認証が完了しました。",
					})
					if (res.user_include_sales == true) {
						this.redirectTo("/")
					} else {
						this.redirectTo("/erp")
					}
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
					if (err.response.status == 400) {
						this.isSuccess = false
						this.redirectTo("/erp/login")
					}
				})
		},
	},
}
</script>

<style scoped lang="scss">
@import "../../stylesheet/variable.scss";

.complate {
	text-align: center;
	padding-top: 1.5rem;
}

h1 {
	padding: 0.25em 0.5em;
	background: transparent;
	border-left: solid 5px $main-color;
	display: inline;
}
</style>
